export const foreignKeyMapping = {
  contacts: "contact_id",
  deals: "deal_id",
  companies: "company_id",
};

/** The kind of record a note hangs off: a contact, a deal or a company. */
export type NoteReference = keyof typeof foreignKeyMapping;
